<template>
  <div class="itinerary-map-tab">
    <VueImage
      class="
        itinerary-map-tab__image-wrapper
        tw-py-7
        sm:tw-py-0
        lg:tw-py-5 lg:tw-py-7
      "
      :src="itineraryMapSrc"
      alt="Map"
    />
    <HorizontalDivider class="lg:tw-hidden tw-mt-2.5 tw-mb-2.5" />
    <CruiseSliderMobile
      class="lg:tw-hidden"
      :cruise-data="cruiseData"
      :text-labels="textLabels"
      @change-cruise-index="changeCruiseIndex"
    />
  </div>
</template>

<script>
import VueImage from "@/stories/Atoms/VueImage/VueImage.vue";
import CruiseSliderMobile from "@/stories/Components/CruiseItineraryDetail/Elements/mobile/CruiseSliderMobile/CruiseSliderMobile.vue";
import HorizontalDivider from "@/stories/Atoms/HorizontalDivider/HorizontalDivider.vue";

export default {
  name: "ItineraryMap",

  components: {
    VueImage,
    CruiseSliderMobile,
    HorizontalDivider,
  },

  props: {
    cruiseData: {
      type: Array,
      default: () => [],
      required: true,
    },
    activeCruiseIndex: {
      type: Number,
      default: 0,
      required: true,
    },
    textLabels: {
      type: Object,
      required: true,
      default: () => {},
    },
    isDesktop: {
      type: Boolean,
      default: false,
      required: true,
    },
  },

  computed: {
    itineraryMapSrc() {
      return this.cruiseData[this.activeCruiseIndex]?.MapImage;
    },
  },

  methods: {
    changeCruiseIndex(index) {
      this.$emit("change-cruise-index", index);
    },
  },
};
</script>

<style lang="scss">
@import "ItineraryMapTab";
</style>
